import checkout from "./form";

const {
  formField: { name, description, startDate, endDate, progress, Status, projectId },
} = checkout;

const initialValues = {
  [name.name]: "",
  [description.name]: "",
  [startDate.name]: new Date().toISOString().slice(0, 10),
  [endDate.name]: new Date().toISOString().slice(0, 10),
  [progress.name]: 0,
  [Status.name]: 0,
  [projectId.name]: "",
};

export default initialValues;
